const ROLE_CLAIM =
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

export const decodeToken = (token) => {
  if (!token || typeof token !== "string") return null;
  try {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) return null;
    return JSON.parse(atob(tokenParts[1]));
  } catch (error) {
    return null;
  }
};

export const getRoleFromToken = (token) => {
  const payload = decodeToken(token);
  if (!payload) return null;
  const claim = payload[ROLE_CLAIM];
  if (typeof claim === "string" && claim.length > 0) {
    return claim.toLowerCase();
  }
  if (Array.isArray(claim)) {
    const first = claim.find((v) => typeof v === "string" && v.length > 0);
    return first ? first.toLowerCase() : null;
  }
  return null;
};

export const isTokenExpired = (token) => {
  const payload = decodeToken(token);
  if (!payload || typeof payload.exp !== "number") return true;
  const currentTime = Date.now() / 1000;
  return payload.exp < currentTime;
};

export const isImpersonating = (token) => {
  const payload = decodeToken(token);
  if (!payload) return false;
  return payload.imp === true || payload.imp === "true";
};

export const getImpersonatorId = (token) => {
  const payload = decodeToken(token);
  if (!payload) return null;
  const impersonatorId = payload.imp_by;
  return typeof impersonatorId === "string" && impersonatorId.length > 0
    ? impersonatorId
    : null;
};
